import React, { Fragment } from "react"
import { PlanVisual } from "./janowoTwoStyle"
import { Col, Container, Row } from "react-bootstrap"
import EstateSlider from "@/components/estates/estateSlider"
import EstateMainSlider from "@/components/estates/estateMainSlider"

const JanowoTwoVisual = ({ image = null, slides = [], alt = " " }) => {
  return (
    <Fragment>
      <PlanVisual>
        {image && (
          <Container className="">
            <Row>
              <Col
                style={{ margin: "0 auto 25px", padding: 0 }}
                xs="0"
                sm="0"
                md="12"
              >
                <div style={{ textAlign: "center" }}>
                  <img src={image} alt={alt} />
                </div>
              </Col>
            </Row>
          </Container>
        )}
        {slides?.length ? (
          <div className="slider-wrapper">
            <Container>
              <Row>
                <Col
                  style={{
                    margin: "0 -14px 25px",
                    maxWidth: "calc(100% + 28px)",
                  }}
                >
                  <EstateMainSlider slides={slides} />
                </Col>
              </Row>
            </Container>
          </div>
        ) : (
          ""
        )}
      </PlanVisual>
    </Fragment>
  )
}

export default JanowoTwoVisual
